import React from 'react';
import styled from 'styled-components';

type MessageSentProps = Omit<React.SVGProps<SVGSVGElement>, 'ref'> & {
  color?: string;
  scale?: number;
};

const StyledSvg = styled.svg.withConfig({
  shouldForwardProp: (prop) => prop !== 'scale',
})<{ scale?: number }>`
  color: var(--way-colors-svgColor);
  height: ${({ scale = 1 }) => 8 * scale}px;
  width: ${({ scale = 1 }) => 8 * scale}px;
`;

const MessageSent = ({ color, scale, ...props }: MessageSentProps) => {
  return (
    <StyledSvg
      fill="none"
      scale={scale}
      style={{ color }}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8312 4.7998H36.8137V17.2384L43.1998 19.4244V43.1998H4.7998V19.4244L10.8312 17.3599V4.7998ZM10.8312 18.6656L6.80114 20.045L10.8312 22.6588V18.6656ZM12.0375 23.4411L24.4936 31.5196L35.6074 23.9111V6.03851H12.0375V23.4411ZM36.8137 23.0853L41.236 20.0579L36.8137 18.5442V23.0853ZM41.9935 21.028L24.5113 32.9962L6.00609 20.9945V41.9611H41.9935V21.028Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4491 20.6031L30.8132 11.6127L31.5392 12.3931L22.8121 21.7737C22.6116 21.9892 22.2866 21.9892 22.0861 21.7737L17.4659 16.8075L18.1919 16.0271L22.4491 20.6031Z"
        fill="black"
        fillOpacity="0.8"
      />
    </StyledSvg>
  );
};

export default MessageSent;
